<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Send To Next Process
            </h2>
        </v-card-title>
        <v-divider class="mx-6" />
        <v-card-text
            :style="{ 'max-height': height + 'px', 'overflow-y': 'auto' }"
        >
            <v-form v-model="valid">
                <v-data-table
                    :headers="headers"
                    :items="filteredItems"
                    class="elevation-0 mt-7"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="6" class="d-flex align-center">
                                <h2 class="my-n3 d-flex align-center">
                                    ITEMS
                                </h2></v-col
                            >

                            <v-col cols="6" class="d-flex justify-end">
                                <div
                                    class="d-flex align-center"
                                    style="gap: 16px"
                                >
                                    <v-combobox
                                        v-model="prevProcess"
                                        hide-details
                                        prefix="Origin Process *"
                                        prepend-icon="mdi-tools"
                                        :items="availableOriginProcesses"
                                        item-text="name"
                                        :rules="[rules.required]"
                                        required
                                        class="ma-0 pa-0"
                                        style="min-width: 300px"
                                        @change="calculateValues"
                                    />
                                    <v-combobox
                                        v-model="nextProcess"
                                        hide-details
                                        prefix="Destination Process *"
                                        prepend-icon="mdi-tools"
                                        :items="filteredAvailableProcesses"
                                        item-text="name"
                                        :rules="[rules.required]"
                                        required
                                        class="ma-0 pa-0"
                                        style="min-width: 300px"
                                        @change="calculateValues()"
                                        :disabled="
                                            filteredAvailableProcesses.length <=
                                                0
                                        "
                                    />
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                            class="pt-2"
                        />
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.index`]="{ index }">
                        <p class="my-0">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">{{ item.code }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <div>
                            <p class="my-0">{{ item.description }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.suggestedProcess`]>
                        <div class="d-flex justify-center">
                            <p class="my-0">
                                {{
                                    nextProcess
                                        ? nextProcess.name
                                        : 'There is no next process'
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.available`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">
                                {{ item.available }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.qty`]="{ item }">
                        <div class="mb-5">
                            <v-text-field
                                v-model="item.qtyToSend"
                                hide-details
                                type="number"
                                :rules="() => maxValue(item)"
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.assemblyWO`]="{ item }">
                        <div class="mb-5">
                            <v-combobox
                                v-model="item.destinationAssemblyWorkOrder"
                                hide-details
                                :items="item.assemblyWorkOrders"
                                item-text="code"
                                required
                                class="mb-5"
                                :disabled="
                                    !nextProcess ||
                                        item.processes[
                                            item.processes.length - 1
                                        ] != nextProcess.id
                                "
                                v-if="
                                    nextProcess && nextProcess.assemblyProcess
                                "
                            />
                        </div>
                    </template>
                    <template v-slot:no-data>
                        <v-alert
                            v-if="
                                prevProcess &&
                                    nextProcess &&
                                    prevProcess.id !== nextProcess.id
                            "
                            type="info"
                            class="mx-4 my-2"
                            text
                        >
                            No items available to send from the selected Origin
                            Process.
                        </v-alert>
                    </template>
                </v-data-table>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                :loading="loading"
                color="primary"
                rounded
                class="mb-3 mr-3"
                :disabled="disableButton() || !valid"
                @click="openConfirmDialog"
            >
                NEXT
            </v-btn>
        </v-card-actions>
        <v-dialog
            :retain-focus="false"
            v-model="confirmDialog"
            persistent
            max-width="700px"
        >
            <v-card>
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="closeConfirmDialog"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">
                        Confirm Send to
                        {{ nextProcess ? nextProcess.name : '' }}
                    </h2>
                </v-card-title>
                <v-divider class="mx-6" />
                <v-card-text>
                    <v-form v-model="valid">
                        <v-data-table
                            :headers="confirmHeaders"
                            :items="
                                workOrder.items.filter(
                                    i => i.qtyToSend && i.qtyToSend > 0
                                )
                            "
                            class="elevation-0 mt-7"
                            :mobile-breakpoint="0"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                            :style="{
                                'max-height': height + 'px',
                                'overflow-y': 'auto',
                            }"
                        >
                            <template v-slot:top>
                                <v-row
                                    no-gutter
                                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                                    :style="{ 'background-color': '#eeeeee' }"
                                >
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                    >
                                        <h2 class="my-n3 d-flex align-center">
                                            ITEMS
                                        </h2></v-col
                                    >
                                </v-row>
                            </template>
                            <!--ITEMS-->
                            <template v-slot:[`item.code`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.code }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.qty`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.qtyToSend }}</p>
                                </div>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-5">
                    <v-row class="ma-2">
                        <!-- Batch Progress Indicator -->
                        <div
                            v-if="batchProgress.isProcessing"
                            class="d-flex align-center mr-4"
                        >
                            <span class="text-caption">
                                Processing batch {{ batchProgress.current }} of
                                {{ batchProgress.total }}
                            </span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-col cols="3" class="d-flex justify-end pa-0 ">
                            <v-btn
                                color="primary"
                                rounded
                                :disabled="!valid || batchProgress.isProcessing"
                                :loading="loading"
                                @click="sendItems"
                            >
                                <v-icon v-if="batchProgress.isProcessing" left
                                    >mdi-loading</v-icon
                                >
                                {{
                                    batchProgress.isProcessing
                                        ? 'PROCESSING...'
                                        : 'SEND'
                                }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'MultipleSend',
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        processes: { type: Object, required: true },
    },
    data: () => ({
        valid: false,
        loading: false,
        batchSize: 100, // Number of items to process per batch
        batchProgress: {
            current: 0,
            total: 0,
            isProcessing: false,
        },
        batchInfo: {
            totalItems: 0,
            totalBatches: 0,
            itemsPerBatch: 100,
        },
        headers: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'NEXT PROCESS',
                value: 'suggestedProcess',
                align: 'center',
                sortable: false,
            },
            {
                text: 'AVAILABLE QTY',
                value: 'available',
                align: 'center',
                sortable: false,
                width: '130',
            },
            {
                text: 'QTY TO SEND',
                value: 'qty',
                align: 'center',
                sortable: false,
                width: '130',
            },
        ],
        confirmHeaders: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QUANTITY TO SEND',
                value: 'qty',
                align: 'center',
                sortable: false,
            },
        ],
        rules: {
            required: v => !!v || 'The value is required',
        },

        availableProcesses: [],
        prevProcess: undefined,
        nextProcess: undefined,
        confirmCode: undefined,
        code: undefined,
        confirmDialog: false,
        height: 0,
        partNumberToFilter: undefined,
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        projectWorkOrders: [],
        availableAssemblyProcess: [],
        availableOriginProcesses: [],
    }),
    computed: {
        filteredItems() {
            let conditions = []
            conditions.push(this.filterAvailable)

            if (this.partNumberToFilter) {
                conditions.push(this.filterForPartNumber)
            }

            if (this.nextProcess) {
                conditions.push(this.filterForNextProcess)
            }

            if (conditions.length > 0) {
                return this.workOrder.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.workOrder.items
        },
        filteredAvailableProcesses() {
            if (!this.prevProcess) return []

            const nextProcessIds = new Set()

            // Find the immediate next process for each item that has the origin process
            this.workOrder.items.forEach(item => {
                const procs = Array.isArray(item.processes)
                    ? item.processes
                    : []

                const originIndex = procs.findIndex(
                    pid => pid === this.prevProcess.id
                )

                // Only process items that have the origin process
                if (originIndex >= 0 && originIndex < procs.length - 1) {
                    // Get the process immediately after the origin
                    let nextIndex = originIndex + 1
                    let nextProcessId = procs[nextIndex]

                    // Skip quality process if it's the immediate next (quality is not a destination)
                    if (nextProcessId === this.qualityProcess.id) {
                        nextIndex++
                        if (nextIndex < procs.length) {
                            nextProcessId = procs[nextIndex]
                        } else {
                            nextProcessId = null
                        }
                    }

                    // Add the immediate next process (if it exists and is not quality)
                    if (
                        nextProcessId &&
                        nextProcessId !== this.qualityProcess.id
                    ) {
                        nextProcessIds.add(nextProcessId)
                    }
                }
            })

            // Convert process IDs to process objects
            return Array.from(nextProcessIds)
                .map(id => {
                    // Find in configured processes
                    const found = this.processes.processes.find(
                        p => p.id === id
                    )
                    if (found) return found

                    // Check if it's packing process
                    if (id === this.packingProcess.id) {
                        return this.packingProcess
                    }

                    return null
                })
                .filter(p => p !== null)
        },
    },
    watch: {
        prevProcess: _.debounce(function() {
            this.resetSelectionOnOriginChange()
            this.calculateValues()
        }, 100),
        nextProcess: _.debounce(function() {
            this.calculateValues()
        }, 100),
        'workOrder.items': {
            handler: _.debounce(function() {
                this.calculateValues()
            }, 200),
            deep: true,
        },
    },
    async mounted() {
        this.workOrder.items.forEach(item => {
            if (this.user.process) {
                const userProcessIds = this.user.process.map(p => p.id)
                const userProcessIndex = item.processes.findIndex(p =>
                    userProcessIds.includes(p)
                )

                item.processes.forEach((process, index) => {
                    if (index > userProcessIndex) {
                        const processIndex = this.processes.processes.findIndex(
                            p => p.id == process
                        )

                        if (processIndex > -1) {
                            const existingProcess = this.availableProcesses.find(
                                ap => ap.id == process
                            )

                            if (!existingProcess) {
                                this.availableProcesses.push(
                                    this.processes.processes[processIndex]
                                )
                            }
                        } else {
                            if (this.workOrder.assemblyWorkOrder != undefined) {
                                if (process == this.packingProcess.id) {
                                    const existingProcess = this.availableProcesses.find(
                                        ap => ap.id == process
                                    )
                                    if (!existingProcess) {
                                        this.availableProcesses.push(
                                            this.packingProcess
                                        )
                                    }
                                }
                            }
                        }
                    }
                })

                if (this.workOrder.assemblyWorkOrder == undefined) {
                    this.availableProcesses.push(this.packingProcess)
                }

                const filteredProcesses = this.availableProcesses.filter(
                    p =>
                        userProcessIds.includes(p.id) &&
                        p.id != this.qualityProcess.id
                )
                this.availableProcesses = filteredProcesses

                const userProcessOriginIds = this.user.process.map(p => p.id)
                this.availableOriginProcesses = this.processes.processes.filter(
                    p => userProcessOriginIds.includes(p.id)
                )

                const hasPacking = this.availableProcesses.some(
                    p => p.id === this.packingProcess.id
                )
                const isLastProcessForAnyItem = this.workOrder.items.some(
                    item => {
                        const processes = item.processes
                        return (
                            processes &&
                            processes[processes.length - 1] ===
                                this.packingProcess.id
                        )
                    }
                )

                if (!hasPacking && isLastProcessForAnyItem) {
                    this.availableProcesses.push(this.packingProcess)
                }
                this.findNextProcess(item)
            }
        })

        if (this.user && this.user.process) {
            this.calculateValues()
        }
        this.onResize()
        this.projectWorkOrders = await API.getWorkOrdersByProject({
            projectId: this.workOrder.projectId,
            includeClosed: false,
        })
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        getAvailableAssemblyWOs(item) {
            return this.projectWorkOrders.filter(workOrder => {
                if (
                    !workOrder.assemblyWorkOrder ||
                    this.workOrder.code === workOrder.code ||
                    !workOrder.partNumbers ||
                    !['approved', 'finished'].includes(workOrder.status)
                ) {
                    return false
                }

                for (const partNumberKey in workOrder.partNumbers) {
                    const partNumber = workOrder.partNumbers[partNumberKey]

                    if (!partNumber.assemblyItems) continue

                    const found = Object.values(partNumber.assemblyItems).some(
                        assemblyItem =>
                            assemblyItem.partNumberId === item.partNumberId
                    )

                    if (found) return true
                }

                return false
            })
        },

        async sendItems() {
            try {
                this.loading = true
                const itemsToUpdate = this.workOrder.items
                    .filter(i => i.qtyToSend && i.qtyToSend > 0)
                    .map(fi => ({
                        partNumberId: fi.partNumberId,
                        qtyToSend: fi.qtyToSend,
                    }))

                // Process items in batches
                const allProcessedItems = []
                const totalBatches = Math.ceil(
                    itemsToUpdate.length / this.batchSize
                )

                // Initialize batch progress
                this.batchProgress = {
                    current: 0,
                    total: totalBatches,
                    isProcessing: true,
                }

                for (let i = 0; i < itemsToUpdate.length; i += this.batchSize) {
                    const batch = itemsToUpdate.slice(i, i + this.batchSize)
                    const currentBatchNumber =
                        Math.floor(i / this.batchSize) + 1

                    // Update progress
                    this.batchProgress.current = currentBatchNumber

                    try {
                        const batchResult = await API.sendBatchToNextProcess({
                            items: batch,
                            workOrderId: this.workOrder.id,
                            prevProcess: this.prevProcess,
                            nextProcess: this.nextProcess,
                        })

                        // Handle different response formats
                        if (Array.isArray(batchResult)) {
                            allProcessedItems.push(...batchResult)
                        } else if (
                            batchResult &&
                            typeof batchResult === 'object'
                        ) {
                            // If it's an object, check if it has a data property or items property
                            if (
                                batchResult.data &&
                                Array.isArray(batchResult.data)
                            ) {
                                allProcessedItems.push(...batchResult.data)
                            } else if (
                                batchResult.items &&
                                Array.isArray(batchResult.items)
                            ) {
                                allProcessedItems.push(...batchResult.items)
                            } else {
                                // If it's just a single object, push it directly
                                allProcessedItems.push(batchResult)
                            }
                        } else {
                            // If it's not an array or object, just push it as is
                            allProcessedItems.push(batchResult)
                        }

                        // Add a small delay between batches to prevent overwhelming the server
                        if (i + this.batchSize < itemsToUpdate.length) {
                            await new Promise(resolve =>
                                setTimeout(resolve, 100)
                            )
                        }
                    } catch (error) {
                        this.setErrorItems({
                            source: this.$options.name,
                            message: error.message,
                        })
                    }
                }

                // Reset batch progress
                this.batchProgress.isProcessing = false

                this.workOrder.items.forEach(item => {
                    delete item.qtyToSend
                })
                const lastResult =
                    allProcessedItems.length > 0
                        ? allProcessedItems[allProcessedItems.length - 1]
                        : null
                this.$emit('closeDialog', lastResult)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        calculateValues() {
            if (!this.nextProcess || !this.prevProcess) return

            this.workOrder.items.forEach(item => {
                const isImmediateNext = this.filterForNextProcess(item)
                if (!isImmediateNext) {
                    item.available = 0
                    item.qtyToSend = 0
                    return
                }

                const prevId = this.prevProcess.id
                const nextId = this.nextProcess.id

                const totalProduced =
                    item.production
                        ?.filter(p => p.process?.id === prevId)
                        .reduce((sum, p) => sum + p.qty, 0) || 0

                const totalDelivered =
                    item.deliveries
                        ?.filter(
                            d =>
                                d.prevProcess?.id === prevId &&
                                d.nextProcess?.id === nextId
                        )
                        .reduce((sum, d) => sum + d.qty, 0) || 0

                let available = 0
                if (prevId === this.qualityProcess.id) {
                    const released =
                        item.quality?.reduce(
                            (sum, q) => sum + (q.releaseQty || 0),
                            0
                        ) || 0
                    available = released - totalDelivered
                } else {
                    available = totalProduced - totalDelivered
                }

                item.available = available > 0 ? available : 0
                item.qtyToSend = item.available
            })
        },

        resetSelectionOnOriginChange() {
            this.nextProcess = undefined
            this.workOrder.items.forEach(item => {
                item.qtyToSend = 0
                item.available = 0
                item.destinationAssemblyWorkOrder = undefined
            })
        },

        findNextProcess(item) {
            try {
                let processes = []
                item.processes.forEach(processId => {
                    if (processId == this.qualityProcess.id) {
                        processes.push(this.qualityProcess)
                    } else if (processId == this.packingProcess) {
                        processes.push(this.packingProcess)
                    } else {
                        const foundProcess = item.dataProcesses.find(
                            p => p.id == processId
                        )
                        if (foundProcess) {
                            processes.push(foundProcess)
                        }
                    }
                })

                if (this.workOrder.assemblyWorkOrder == undefined) {
                    processes.push(this.packingProcess)
                }
                const userProcessIds = this.user.process.map(p => p.id)

                const processIndex = processes.findIndex(p =>
                    userProcessIds.includes(p.id)
                )

                let nextProcess

                if (processIndex > -1 && processIndex + 1 < processes.length) {
                    nextProcess = processes[processIndex + 1]
                    if (
                        nextProcess.id == this.qualityProcess.id &&
                        processIndex + 2 < processes.length
                    ) {
                        nextProcess = processes[processIndex + 2]
                    }
                }

                item.nextProcess = nextProcess
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },

        matchCode() {
            return !!(
                this.code &&
                this.confirmCode &&
                this.code === this.confirmCode
            )
        },

        openConfirmDialog() {
            // Calculate batch information
            const selectedItems = this.workOrder.items.filter(
                i => i.qtyToSend && i.qtyToSend > 0
            )
            this.batchInfo = {
                totalItems: selectedItems.length,
                totalBatches: Math.ceil(selectedItems.length / this.batchSize),
                itemsPerBatch: this.batchSize,
            }

            this.confirmDialog = true
        },

        closeConfirmDialog() {
            this.confirmDialog = false
        },

        close() {
            this.workOrder.items.forEach(item => {
                delete item.qtyToSend
            })
            this.$emit('closeDialog')
        },
        disableButton() {
            return (
                !this.filteredItems.some(item => item.available > 0) ||
                !this.prevProcess ||
                !this.nextProcess ||
                this.prevProcess.id === this.nextProcess.id ||
                this.batchProgress.isProcessing
            )
        },
        onResize() {
            this.height = window.innerHeight - 260
        },

        filterAvailable(item) {
            return item.available && item.available > 0
        },

        filterForPartNumber(item) {
            return (
                item.partNumber &&
                item.partNumber
                    .toLowerCase()
                    .includes(this.partNumberToFilter.toLowerCase())
            )
        },

        filterForNextProcess(item) {
            if (!this.nextProcess || !this.prevProcess) return false
            if (this.prevProcess.id === this.nextProcess.id) return false

            const procs = Array.isArray(item.processes) ? item.processes : []
            const originIdx = procs.findIndex(
                pid => pid === this.prevProcess.id
            )

            // Item must have the origin process
            if (originIdx < 0) return false

            // Item must have at least one more process after origin
            if (originIdx >= procs.length - 1) return false

            // Get the process immediately after the origin
            let nextIndex = originIdx + 1
            let immediateNextProcessId = procs[nextIndex]

            // Skip quality process if it's the immediate next (quality is not a destination)
            if (immediateNextProcessId === this.qualityProcess.id) {
                nextIndex++
                if (nextIndex < procs.length) {
                    immediateNextProcessId = procs[nextIndex]
                } else {
                    // No process after quality, so this item doesn't have the destination
                    return false
                }
            }

            // The immediate next process must match the selected destination
            return immediateNextProcessId === this.nextProcess.id
        },

        maxValue(item) {
            return item.qtyToSend > item.available ||
                (item.qtyToSend < 0 &&
                    item.qtyToSend != undefined &&
                    item.qtyToSend != null)
                ? 'The quantity to be sent cannot be greater than the quantity available'
                : true
        },
    },
}
</script>

<style></style>
